import React from 'react';
import { connect } from 'redux-bundler-react';
import PluginRegion from '../utils/plugin-region';
import UpperRightToolbar from './upper-right-toolbar';
import LowerRightToolbar from './lower-right-toolbar';

class RightSidebar extends React.Component {
  render() {
    const { theme, componentsRightSidebarBottom, componentsRightSidebarTop } = this.props;

    return (
      <div className={'sidebar sidebar-right ' + theme}>

        <PluginRegion
          className="sidebar-buttons-top"
          components={componentsRightSidebarTop}
        />

        <PluginRegion
          className="sidebar-buttons-bottom"
          components={componentsRightSidebarBottom}
        />

        <UpperRightToolbar />

        <LowerRightToolbar />

      </div>
    )
  }
}

export default connect(
  'selectTheme',
  'selectComponentsRightSidebarTop',
  'selectComponentsRightSidebarBottom',
  RightSidebar
)